module.exports = __webpack_public_path__ + "static/media/Bitter-Bold.d513fc8e.ttf";